import { useEffect, useState } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import moment from 'src/services/moment_instance';
import styled from '@emotion/styled';
import crecerForms from 'src/services/api/crecer';
import Swal from 'sweetalert2';
import { screenSizes } from 'src/assets/styles/Literals';

const RelationDetailsContainer = styled.div`
  .relation-details__section {
    margin-bottom: 30px;
    padding: 20px;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: #f8f9fa;

    h3 {
      margin: 0 0 15px 0;
      color: #495057;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 2px solid #dee2e6;
      padding-bottom: 8px;
    }
  }

  .relation-details__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 15px;
  }

  .relation-details__item {
    padding: 10px;
    background: white;
    border-radius: 6px;
    border: 1px solid #e9ecef;

    strong {
      color: #495057;
      font-weight: 600;
    }
  }

  .relation-details__answers {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 10px;
  }

  .relation-details__answer-item {
    padding: 8px 12px;
    background: white;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    font-size: 14px;

    strong {
      color: #495057;
      font-weight: 600;
      display: block;
      margin-bottom: 4px;
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    .relation-details__grid {
      grid-template-columns: 1fr;
    }

    .relation-details__answers {
      grid-template-columns: 1fr;
    }
  }
`;

const RelationsGuestAnswers = (props) => {
  const { setShowDetails, selectedRelation, getAllRelationsForm } = props;
  const [isWaitlist, setIsWaitlist] = useState(!!selectedRelation?.waitlist);
  const [togglingWaitlist, setTogglingWaitlist] = useState(false);

  useEffect(() => {
    setIsWaitlist(!!selectedRelation?.waitlist);
  }, [selectedRelation]);

  // Helper function to format question text
  const formatQuestionText = (key) => {
    const questionMap = {
      // Area Relacional y emocional
      emotionalDisorders_incapacidad_relacionarse: 'Incapacidad de relacionarse con otros',
      emotionalDisorders_timidez: 'Timidez',
      emotionalDisorders_inseguridad_personal: 'Inseguridad personal',
      emotionalDisorders_baja_autoestima: 'Baja autoestima',
      emotionalDisorders_miedo_soledad_compromiso: 'Miedo a la soledad o al compromiso',
      emotionalDisorders_relaciones_dependientes: 'Relaciones dependientes',

      // Area Sexual
      sexualAnswers_masturbacion: 'Masturbación',
      sexualAnswers_pornografia: 'Pornografía',
      sexualAnswers_adulterio: 'Adulterio',
      sexualAnswers_fornicacion: 'Fornicación',
      sexualAnswers_prostitucion: 'Prostitución',
      sexualAnswers_homosexualismo: 'Confusión en la identidad de género',

      // Area salud mental
      misbehaviours_ataques_panico: 'Ataques de pánico',
      misbehaviours_intento_suicida: 'Intento suicida',
      misbehaviours_descontrol_emocional: 'Descontrol emocional',
      misbehaviours_manejo_ira: 'Manejo inadecuado de la ira',
      misbehaviours_auto_lesion: 'Conductas de auto lesión',
      misbehaviours_anorexia_bulimia: 'Anorexia y/o bulimia',
      misbehaviours_adiccion_drogas: 'Adicción a las drogas',
      misbehaviours_adiccion_juegos_azar: 'Adicción a juegos de azar',
      misbehaviours_depresion: 'Depresión',
      misbehaviours_ansiedad: 'Ansiedad',
      misbehaviours_diagnostico_clinico: 'Diagnóstico clínico confirmado',
    };

    return questionMap[key] || key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const handleDelete = () => {
    Swal.fire({
      title: '¿Estás seguro de querer eliminar esta inscripción?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar',
    }).then((result) => {
      if (result.value) {
        crecerForms
          .updateRelationsForm({
            deleted: true,
            guest_id: selectedRelation.Guest.id,
            id: selectedRelation.id,
          })
          .then((res) => {
            setShowDetails(false);
            getAllRelationsForm();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const handleToggleWaitlist = () => {
    const nextWaitlist = !isWaitlist;

    Swal.fire({
      title: nextWaitlist ? '¿Mover a lista de espera?' : '¿Confirmar inscripción?',
      text: nextWaitlist
        ? 'Esta persona dejará de ocupar un cupo y pasará a lista de espera.'
        : 'Esta persona pasará a contar como inscripción regular y ocupará un cupo.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#d33',
      confirmButtonText: nextWaitlist ? 'Sí, mover a lista de espera' : 'Sí, confirmar inscripción',
    }).then((result) => {
      if (!result.value) return;

      setTogglingWaitlist(true);
      crecerForms
        .toggleRelationsWaitlist({
          guest_id: selectedRelation.Guest.id,
          id: selectedRelation.id,
          waitlist: nextWaitlist,
        })
        .then((res) => {
          if (res.data.success) {
            setIsWaitlist(nextWaitlist);
            getAllRelationsForm();
            Swal.fire({
              title: 'Listo',
              text:
                res.data.message ||
                (nextWaitlist
                  ? 'Persona movida a lista de espera.'
                  : 'Persona confirmada correctamente.'),
              icon: 'success',
            });
          } else {
            Swal.fire({
              title: 'No se pudo actualizar',
              text: res.data.message || 'Ocurrió un error al actualizar la lista de espera.',
              icon: 'error',
            });
          }
        })
        .catch((err) => {
          Swal.fire({
            title: 'Error',
            text:
              err?.response?.data?.message || 'Ocurrió un error al actualizar la lista de espera.',
            icon: 'error',
          });
        })
        .finally(() => {
          setTogglingWaitlist(false);
        });
    });
  };

  const handleOpenGuestProfile = () => {
    const identification = selectedRelation?.Guest?.identification;
    const phone = selectedRelation?.Guest?.phone;
    if (!identification || !phone) {
      Swal.fire({
        title: 'No disponible',
        text: 'No se encontró identificación o teléfono del invitado.',
        icon: 'warning',
      });
      return;
    }
    window.open(`/perfil/crecer?identification=${identification}&phone=${phone}`, '_blank');
  };

  return (
    <Modal open onClose={() => setShowDetails(false)} size="large" closeIcon>
      <Modal.Header>Detalles de la Inscripción</Modal.Header>
      <Modal.Content>
        {selectedRelation && (
          <RelationDetailsContainer>
            <div className="relation-details__section">
              <h3>Información Personal</h3>
              <div style={{ marginBottom: 12 }}>
                <Button color="teal" size="mini" onClick={handleOpenGuestProfile}>
                  Ver perfil
                </Button>
              </div>
              <div className="relation-details__grid">
                <div className="relation-details__item">
                  <strong>Nombres:</strong> {selectedRelation?.Guest?.name || '-'}
                </div>
                <div className="relation-details__item">
                  <strong>Apellidos:</strong> {selectedRelation?.Guest?.lastName || '-'}
                </div>
                <div className="relation-details__item">
                  <strong>Identificación:</strong> {selectedRelation?.Guest?.identification || '-'}
                </div>
                <div className="relation-details__item">
                  <strong>Género:</strong> {selectedRelation?.Guest?.gender || '-'}
                </div>
                <div className="relation-details__item">
                  <strong>Fecha de nacimiento:</strong>{' '}
                  {selectedRelation?.Guest?.birthdate
                    ? moment(selectedRelation?.Guest?.birthdate).format('DD/MM/YYYY')
                    : '-'}
                </div>
                <div className="relation-details__item">
                  <strong>Teléfono:</strong>{' '}
                  {selectedRelation?.Guest?.phone
                    ? selectedRelation?.Guest?.phone
                        .toString()
                        .replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')
                    : '-'}
                </div>
                <div className="relation-details__item">
                  <strong>Email:</strong> {selectedRelation?.Guest?.email || '-'}
                </div>
                <div className="relation-details__item">
                  <strong>Estado civil:</strong>{' '}
                  {selectedRelation?.Guest?.civil || selectedRelation.civil_status || '-'}
                </div>
                <div className="relation-details__item">
                  <strong>Es líder de grupo:</strong> {selectedRelation.isLeader ? 'Si' : 'No'}
                </div>
                <div className="relation-details__item">
                  <strong>Lista de espera:</strong> {isWaitlist ? 'Si' : 'No'}
                  <div style={{ marginTop: 10 }}>
                    <Button
                      size="mini"
                      color={isWaitlist ? 'blue' : 'orange'}
                      loading={togglingWaitlist}
                      disabled={togglingWaitlist}
                      onClick={handleToggleWaitlist}
                    >
                      {isWaitlist ? 'Confirmar inscripción' : 'Mover a lista de espera'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            <div className="relation-details__section">
              <h3>Información del Líder</h3>
              <div className="relation-details__grid">
                <div className="relation-details__item">
                  <strong>Nombre del líder:</strong>{' '}
                  {selectedRelation?.Guest?.GuestLeader?.leaderFullName || '-'}
                </div>
                <div className="relation-details__item">
                  <strong>Teléfono del líder:</strong>{' '}
                  {selectedRelation?.Guest?.GuestLeader?.leaderPhone || '-'}
                </div>
              </div>
            </div>

            {/* Area Relacional y emocional */}
            {selectedRelation.emotionalDisorders && (
              <div className="relation-details__section">
                <h3>Area Relacional y emocional</h3>
                <div className="relation-details__answers">
                  {Object.entries(selectedRelation.emotionalDisorders).map(([key, value]) => (
                    <div key={key} className="relation-details__answer-item">
                      <strong>{formatQuestionText(key)}:</strong>{' '}
                      {value === 'Sí' ? 'Sí' : value === 'No' ? 'No' : value || 'No respondió'}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Area Sexual */}
            {selectedRelation.sexualAnswers && (
              <div className="relation-details__section">
                <h3>Area Sexual</h3>
                <div className="relation-details__answers">
                  {Object.entries(selectedRelation.sexualAnswers).map(([key, value]) => (
                    <div key={key} className="relation-details__answer-item">
                      <strong>{formatQuestionText(key)}:</strong>{' '}
                      {value === 'Sí' ? 'Sí' : value === 'No' ? 'No' : value || 'No respondió'}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Area salud mental */}
            {selectedRelation.misbehaviours && (
              <div className="relation-details__section">
                <h3>Area salud mental</h3>
                <div className="relation-details__answers">
                  {Object.entries(selectedRelation.misbehaviours).map(([key, value]) => (
                    <div key={key} className="relation-details__answer-item">
                      <strong>{formatQuestionText(key)}:</strong>{' '}
                      {key === 'misbehaviours_diagnostico_clinico'
                        ? value || 'No especificado'
                        : value === 'Sí'
                        ? 'Sí'
                        : value === 'No'
                        ? 'No'
                        : value || 'No respondió'}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="relation-details__section">
              <h3>Información del Sistema</h3>
              <div className="relation-details__grid">
                <div className="relation-details__item">
                  <strong>Fecha de inscripción:</strong>{' '}
                  {selectedRelation.createdAt
                    ? moment(selectedRelation.createdAt).format('DD/MM/YYYY HH:mm')
                    : '-'}
                </div>
              </div>
            </div>
          </RelationDetailsContainer>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={handleDelete}>
          Eliminar
        </Button>
        <Button primary onClick={() => setShowDetails(false)}>
          Cerrar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default RelationsGuestAnswers;
